var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('datatable',{ref:"datatable",attrs:{"user":_vm.user,"isAuth":_vm.isAuth},on:{"destroy":_vm.destroy,"create":function($event){_vm.$refs.create.open()}}}),_vm._v(" "),(_vm.user.hasRole(['admin', 'manager']))?_c('create',{ref:"create",attrs:{"user":_vm.user,"isAuth":_vm.isAuth},on:{"reload":_vm.reload}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd7d9a26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/projects/teams/views/html/Index.html
// module id = null
// module chunks = 